import React, { useEffect, useState } from 'react';
import {
  TitleContainer,
  ModalTitle,
  ModalButtonsContainer,
  Column,
  ButtonModalCancel,
  XIcon,
  EditContainer,
  ModalTitleInput,
  Icons,
  SaveIcon,
  EditIcon,
  SmallModalContainer,
  Background,
  ModalTitleSmall,
  ButtonContainerGap,
  StyledButton,
  CloseIcon,
  Subtitle,
  ButtonText,
} from './ModalComponent.styles';

import Modal from './Modal';
import { Waveform } from '@uiball/loaders';
import Button from '../utils/Button/Button';
import { ReactComponent as Delete } from '../../assets/icons/delete.svg';

const ModalComponent = ({
  isOpen,
  onClose,
  rightIcon,
  children,
  title,
  onCreate,
  createDisabled,
  cancelDisabled,
  contentLoading,
  loading,
  subtitle,
  width,
  notShowButtons,
  rightButtonTitle,
  editable,
  deleteIcon,
  appointment,
  onClickDelete,
  newTitle,
  setNewTitle,
  onEdit,
  editLoading,
  setEdit,
  deleteLoading,
  edit,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [isVisible, setIsVisible] = useState(openModal);

  const handleKeyDown = e => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    let timer;
    if (openModal) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 250);
    }

    return () => clearTimeout(timer);
  }, [openModal]);

  return (
    <Modal isOpen={isOpen} width={width}>
      <div style={{ height: '100%', overflowX: 'auto' }}>
        <TitleContainer>
          <EditContainer>
            {!editable && <ModalTitle>{title}</ModalTitle>}
            {rightIcon}
            {!contentLoading && editable && (
              <>
                <Icons
                  onClick={() => {
                    if (!editLoading) {
                      setEdit(!edit);
                    }
                  }}>
                  {editLoading ? (
                    <Waveform size={18} lineWeight={2.5} speed={1} color="black" />
                  ) : !edit ? (
                    <CloseIcon />
                  ) : (
                    <EditIcon />
                  )}
                </Icons>
                <ModalTitleInput
                  placeholder={newTitle}
                  value={newTitle}
                  onChange={e => setNewTitle(e.target.value)}
                  disabled={edit}
                  $edit={edit}
                />

                {!edit && !editLoading && <SaveIcon onClick={onEdit} />}
              </>
            )}
          </EditContainer>

          {deleteIcon ? (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
              <Delete
                className="icon-delete"
                width={24}
                height={24}
                onClick={() => {
                  setOpenModal(true);
                }}
              />
              <XIcon onClick={onClose} />
            </div>
          ) : (
            <XIcon onClick={onClose} />
          )}
        </TitleContainer>
        {!editable && subtitle && <Subtitle>{subtitle}</Subtitle>}

        <Column>{children}</Column>
      </div>
      {!notShowButtons && (
        <ModalButtonsContainer>
          <ButtonModalCancel onClick={onClose} disabled={cancelDisabled}>
            Cancel
          </ButtonModalCancel>
          {!loading ? (
            <Button
              title={rightButtonTitle ? rightButtonTitle : 'Create'}
              disabled={createDisabled}
              containerStyle={{ width: '160px' }}
              onClick={loading ? () => {} : onCreate}
            />
          ) : (
            <ButtonModalCancel $disabled>
              <Waveform size={26} lineWeight={3.5} speed={1} color="black" />
            </ButtonModalCancel>
          )}
        </ModalButtonsContainer>
      )}

      {isVisible && (
        <>
          <Background $open={openModal} />
          <SmallModalContainer $open={openModal}>
            <ModalTitleSmall style={{ textAlign: 'center' }}>
              {appointment
                ? 'Are you sure you want to delete this appointment?'
                : 'Are you sure you want to delete this template?'}
            </ModalTitleSmall>
            <ButtonContainerGap style={{ gap: 20 }}>
              <StyledButton onClick={() => setOpenModal(false)}>
                <ButtonText>Cancel</ButtonText>
              </StyledButton>

              <StyledButton
                onClick={() => {
                  if (!deleteLoading) {
                    onClickDelete();

                    setTimeout(() => {
                      setOpenModal(false);
                    }, 2000);
                  }
                }}
                $disabled={deleteLoading}
                $black>
                {!deleteLoading ? (
                  <ButtonText $black>Yes</ButtonText>
                ) : (
                  <Waveform size={26} lineWeight={3.5} speed={1} color="white" />
                )}
              </StyledButton>
            </ButtonContainerGap>
          </SmallModalContainer>
        </>
      )}
    </Modal>
  );
};

export default ModalComponent;
